<template>
  <div class='EnbSeo'>
    <div class="card">
      <div class="label">
        <div class="text-label">
          Buscadores
        </div>
        <div class="arrow">
          <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
        </div>
      </div>
      <div class="cont-input" :class="{ continput: sublink }">
        <div class="cont-i">
          <input-reg
          text="Título"
          :cont="{ textAlign: 'left' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
          <input-reg
          text="Descrição"
          :cont="{ textAlign: 'left', marginTop: '8px' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import ArrowIcon from '../Icons/ArrowIcon'
export default {
  name: 'EnbSeo',
  components: { InputReg, ArrowIcon },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['ChangeCompany'])
  }
}
</script>

<style scoped>
.EnbSeo {
  display: flex;
  margin-top: 5.8%;
}

.card {
  width: 100%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  overflow: hidden;
}

.label {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  color: #648EEA;
  font-size: 16px;
  text-align: left;
}

.text-label {
  width: 90%;
}

.text-label {
  padding: 2%;
}

.cont-input {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.continput {
  max-height: 250px;
  transition: max-height 0.15s ease-in;
}

input {
  margin-left: 2%;
}

.cont-i {
  padding: 2%;
}
</style>
